import React from 'react'
import { Currency } from '@mobi/utils/money/currency'
import { AnimatedNumberTransition } from '@mobi/component-library/Common/AnimatedNumberTransition'
import { PriceChange } from '@core/Components/Text/utils'
import {
  LegInfoWrapperStyled,
  SingleLegPriceStyled,
  SingleLegTypeStyled,
} from '../../LegInfo.styles'

export const LegInfoWithPriceComponent: React.FC<{
  legType: string
  price: number
  isActive: boolean
  boostAmount: number
  priceChange: PriceChange
}> = ({ legType, price, isActive = true, boostAmount = 0, priceChange = PriceChange.None }) => {
  const isBoosted = boostAmount > 0
  const finalPrice = new Currency(price || 0).add(boostAmount).format()

  return (
    <LegInfoWrapperStyled>
      <SingleLegTypeStyled data-testid='LegInfo.SingleLeg' isActive={isActive}>
        {legType}
      </SingleLegTypeStyled>

      <SingleLegPriceStyled
        data-tid={`qb-${legType.toLowerCase()}-price`}
        shouldHighlight={isBoosted}
        isActive={isActive}
        priceChange={priceChange}
      >
        {isBoosted ? (
          <AnimatedNumberTransition start={new Currency(price || 0).format()} end={finalPrice} />
        ) : (
          finalPrice
        )}
      </SingleLegPriceStyled>
    </LegInfoWrapperStyled>
  )
}
